export const getFormattedTime = (time: number) => {
  return ('0' + String(time)).slice(-2);
};
